// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3x-ln","item":"PaymentsMobile_item__1aYqt","label":"PaymentsMobile_label__1HaYv","amount":"PaymentsMobile_amount__lnq47"};